import React from "react";
import Fejl404 from "../components/fejl404.js";

const Error404 = () => {
    return (
        <Fejl404 />
    );
  }

export default Error404;